module.exports = __webpack_public_path__ + "img/vastpaneel.60a1c565.svg";